import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { createPredicate } from './condition.js';
import { ExternalCustomEvents } from './utils.js';

//
var initialized = false;
var debug = false;
var PROVIDER = 'Meta';
var emit = true;
var identity = '';
var randomId = 'id' + Math.random().toString(36).substring(2, 15);
/**
 * Utilities
 */
var warn = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!debug) {
        return;
    }
    // eslint-disable-next-line no-console
    console.info.apply(console, ['[meta-pixel]'].concat(args));
};
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!debug) {
        return;
    }
    // eslint-disable-next-line no-console
    console.info.apply(console, ['[meta-pixel]'].concat(args));
};
// function getHourId() {
//   const now = new Date();
//   now.setMinutes(0, 0, 0);
//   const hourTimestamp = now.getTime();
//   return hourTimestamp;
// }
var verifyInit = function () {
    if (!initialized) {
        warn('Pixel not initialized before using call ReactPixel.init with required params');
    }
    return initialized;
};
//
var defaultOptions = {
    autoConfig: true,
};
var activeBrandId = '';
var brandPixels = {};
function isPixelInitialized(brandId, pixelId) {
    var _a;
    var pixels = brandPixels === null || brandPixels === void 0 ? void 0 : brandPixels[brandId];
    if ((_a = pixels === null || pixels === void 0 ? void 0 : pixels.find(function (item) { return item.pixelId === pixelId; })) === null || _a === void 0 ? void 0 : _a.initialized) {
        return true;
    }
    return false;
}
function setPixelInitialized(brandId, pixelId) {
    brandPixels[brandId] = brandPixels[brandId].map(function (item) {
        if (item.pixelId === pixelId) {
            return __assign(__assign({}, item), { // keep other properties
                pixelId: pixelId, initialized: true, eventFilterFn: item.eventFilter ? createPredicate(item.eventFilter) : function () { return true; } });
        }
        return item;
    });
}
var metaPixelHelper = {
    setActiveBrand: function (brand) {
        activeBrandId = brand;
    },
    unload: function () {
        var scriptElement = document.getElementById(randomId);
        if (scriptElement) {
            log('unloading fbq script ...', document.removeChild(scriptElement) ? 'success' : 'failed');
            window.fbq = undefined;
        }
    },
    setBrandPixel: function (brand, pixelId, eventFilter) {
        if (brand) {
            brandPixels[brand] = brandPixels[brand] || [];
            if (!brandPixels[brand].find(function (item) { return item.pixelId === pixelId; }) && pixelId) {
                brandPixels[brand].push({
                    pixelId: pixelId,
                    eventFilter: eventFilter,
                    initialized: false,
                });
            }
            else {
                // replace
                brandPixels[brand] = brandPixels[brand].map(function (item) {
                    if (item.pixelId === pixelId) {
                        return __assign(__assign({}, item), { // keep other properties
                            pixelId: pixelId, eventFilter: eventFilter });
                    }
                    return item;
                });
            }
        }
    },
    getActivePixels: function () {
        return activeBrandId ? brandPixels[activeBrandId] : [];
    },
    initializePixel: function (brandId, pixelId, options) {
        if (isPixelInitialized(brandId, pixelId)) {
            return;
        }
        metaPixelHelper.init(pixelId, identity ? { external_id: identity } : {}, options || defaultOptions);
        setPixelInitialized(brandId, pixelId);
    },
    init: function (pixelId, advancedMatching, options) {
        if (advancedMatching === void 0) { advancedMatching = {}; }
        if (options === void 0) { options = defaultOptions; }
        initialized = typeof window !== 'undefined' && !!window.fbq;
        if (!initialized) {
            initialized = true;
            log('initializing fbq script');
            (function (f, b, e, v, n, t, s) {
                var _a;
                if (f.fbq)
                    return;
                n = f.fbq = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
                };
                if (!f._fbq)
                    f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.id = randomId;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                (_a = s === null || s === void 0 ? void 0 : s.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(t, s);
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        }
        if (!pixelId) {
            warn('Please insert pixel id for initializing');
        }
        else {
            if ((options === null || options === void 0 ? void 0 : options.autoConfig) === false) {
                /*
                  The Meta Pixel will send button click and page metadata (such as data structured according to Opengraph or Schema.org formats)
                  from your website to improve your ads delivery and measurement and automate your Pixel setup. To configure the Meta Pixel to not send this additional
                  information, in the Meta Pixel Base code, add fbq('set', 'autoConfig', 'false', 'FB_PIXEL_ID') above the init call.
                */
                window.fbq('set', 'autoConfig', false, pixelId);
                log("called fbq('set', 'autoConfig', false, '".concat(pixelId, "');"));
            }
            window.fbq('init', pixelId, advancedMatching);
            log("called fbq('init', '".concat(pixelId, "');"));
        }
    },
    trackSingle: function (title, data, isCustom) {
        if (isCustom === void 0) { isCustom = false; }
        if (!verifyInit()) {
            return;
        }
        var activePixels = metaPixelHelper.getActivePixels();
        var eventType = isCustom ? 'trackSingleCustom' : 'trackSingle';
        if (activePixels && (activePixels === null || activePixels === void 0 ? void 0 : activePixels.length) > 0) {
            activePixels.forEach(function (pixel) {
                if (emit) {
                    if (pixel.eventFilterFn && !pixel.eventFilterFn(data)) {
                        log('eventFilterFn failed', pixel.eventFilterFn, data);
                        return;
                    }
                    window.fbq(eventType, pixel.pixelId, title, data);
                }
                if (debug) {
                    log("called fbq('".concat(eventType, "', '").concat(pixel.pixelId, "', '").concat(title, "'); with data "), data);
                }
            });
        }
    },
    trackSingleCustom: function (eventName, data) {
        return metaPixelHelper.trackSingle(eventName, data, true);
    },
};
var metaPixel = {
    enableDebug: function () {
        debug = true;
    },
    setIdentity: function (id) {
        identity = id;
    },
    enableEmitMetrics: function (v) {
        if (v === void 0) { v = true; }
        emit = v;
    },
    track: function (brandId, pixels, eventName, eventPayload) {
        pixels = pixels === null || pixels === void 0 ? void 0 : pixels.filter(function (item) { return item.pixelProvider === PROVIDER; });
        metaPixelHelper.setActiveBrand(brandId);
        if (Array.isArray(pixels) && (pixels === null || pixels === void 0 ? void 0 : pixels.length) > 0) {
            log(JSON.stringify({ brandId: brandId, pixels: pixels, eventName: eventName, payload: eventPayload }));
            if (pixels.length > 0) {
                pixels.forEach(function (pixel) {
                    metaPixelHelper.setBrandPixel(brandId, pixel.pixelId, pixel.eventFilter);
                    metaPixelHelper.initializePixel(brandId, pixel.pixelId, pixel.pixelOptions);
                });
            }
            if (eventName === ExternalCustomEvents.BCBuyBoxClick) {
                eventPayload = __assign({}, eventPayload); // clone
                if (eventPayload.retailPrice) {
                    eventPayload.value = eventPayload.retailPrice;
                    eventPayload.currency = 'USD';
                }
                eventPayload.retailPrice = undefined;
            }
            metaPixelHelper.trackSingleCustom(eventName, eventPayload);
        }
        else {
            metaPixelHelper.unload();
        }
    },
    grantConsent: function () {
        if (!verifyInit()) {
            return;
        }
        window.fbq('consent', 'grant');
        if (debug) {
            log("called fbq('consent', 'grant');");
        }
    },
    revokeConsent: function () {
        if (!verifyInit()) {
            return;
        }
        window.fbq('consent', 'revoke');
        if (debug) {
            log("called fbq('consent', 'revoke');");
        }
    },
};

export { metaPixel as default };
//# sourceMappingURL=metaPixel.js.map
